import { render, staticRenderFns } from "./AnnouncementPreview.vue?vue&type=template&id=8dd0c57c"
import script from "./AnnouncementPreview.vue?vue&type=script&lang=ts"
export * from "./AnnouncementPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports